import Style from "./OrderDetailsStyle";
import Spinner from "../../shared/Spinner/Spinner";
import api from "../../services/api";
import { useEffect, useState } from "react";
import TwoButtonsModal, { Popup } from "../../shared/Bootstrap/TwoButtonsModal";
import {
  CentsToHuman,
  CurrencyToCents,
  PhoneMask,
  ReplaceAll,
  Sort,
} from "../../utils";
import InputCurrency from "../../components/Buttons/InputCurrency";
import { FaTrashAlt, FaPen } from "react-icons/fa";
import { TiCancel } from "react-icons/ti";
import PageTitle from "../../components/PageTitle";
import ReturnButton from "../../components/Buttons/ReturnButton";

interface Product {
  orderItemId: number;
  productId: number;
  variationId: number;
  name: string;
  displayName: string;
  variationName: string;
  price: number;
  variationPriceModification: number;
  modification: {
    name: string;
    price: number;
    removed: number;
    modified: boolean;
  };
  modified: boolean;
}

// interface ApiUserData {
//   accountId?: number;
//   userId?: number;
//   name?: string;
//   email?: string;
//   externalSource?: string | null;
//   phone?: string;
//   cpf?: string;
//   cnpj?: string | null;
//   enterprise?: string;
//   countryCode?: string;
//   zipCode?: string;
//   city?: string;
//   state?: string;
//   neighborhood?: string;
//   address?: string;
//   addressNumber?: string;
//   extendedAddress?: string | null;
//   specialAddress?: string | null;
//   saveId?: number;
//   saveValue?: string;
//   contractId?: number;
//   orderId?: number;
//   orderItems?: { orderId: number; itemId: number; name: string; price: number }[];
//   apartments?: {
//     id: number;
//     userId: number;
//     apartmentId: number;
//     blockId: number;
//     blockName: string;
//     apartmentNumber: string;
//     floor: number;
//     enterpriseId: number;
//     enterpriseName: string;
//   }[];
// }

interface UserData {
  name: string;
  rg: string;
  cpf: string;
  address: string;
  number: string;
  neighborhood: string;
  zip_code: string;
  state: string;
  city: string;
}

interface ChangePopupData {
  title: string;
  body: string;
  primaryText: string;
  secondaryText?: string;
  primaryOnClick?: () => void;
  secondaryOnClick?: () => void;
}

export default function OrderDetails(props) {
  const [loading, setLoading] = useState(true);
  const [order, setOrder] = useState({} as any);
  const [products, setProducts] = useState<Product[]>([]);
  const [materials, setMaterials] = useState<any[]>([]);
  const [planOption, setPlanOption] = useState("" as any);
  const [sumProductsPrice, setSumProductsPrice] = useState(0);
  const [sumMaterialPrice, setSumMaterialPrice] = useState(0);
  const [sumProductsPriceRate, setSumProductsPriceRate] = useState(0);
  const [sumMaterialsPriceRate, setSumMaterialsPriceRate] = useState(0);
  const [artValue, setArtValue] = useState(0);
  const [cleaningTax, setCleaningTax] = useState(0);
  const [userData, setUserData] = useState<UserData | null>(null);

  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState<string>();
  const [showPopUpAddItem, setShowPopUpAddItem] = useState(false);
  const [showPopUp, setShowPopUp] = useState(false);
  const [installment, setInstallment] = useState(false);
  const [listProducts, setListProducts] = useState<any[]>([]);
  const [bodyPopup, setBodyPopUp] = useState<Popup>();
  const [product, setProduct] = useState({ id: 0, name: "", price: "" });

  const orderId = props.match.params.orderId;

  useEffect(() => {
    GetOrderDetails();
    GetProducts();
  }, []);

  useEffect(() => {
    onSumTotal();
  }, [products, materials]);

  async function GetOrderDetails() {
    setLoading(true);
    try {
      const result = await api.get(`orders/${orderId}`);
      setOrder(result.data.order);
      setProducts(result.data.items);
      setMaterials(result.data.materials);
      setArtValue(result.data.order.artValue);
      setCleaningTax(result.data.order.cleaningTaxValue);
      setInstallment(
        result.data.order.newInstallment > 1 || result.data.order.installment > 1
      );
      if (result.data.order.planOption) {
        setPlanOption(result.data.order.planOption);
      }
      // Fetch user data for validation
      const userId = result.data.order.userId; // Assuming userId is in order data
      if (userId) {
        const userResponse = await api.get(`users/${userId}`);
        const apiData = userResponse.data.userData; // Access nested userData
        setUserData({
          name: apiData.name || "",
          rg: apiData.rg || "",
          cpf: apiData.cpf || "",
          address: apiData.address || "",
          number: apiData.addressNumber || "",
          neighborhood: apiData.neighborhood || "",
          zip_code: apiData.zipCode || "",
          state: apiData.state || "",
          city: apiData.city || "",
        });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setErrorMessage(
        "Não foi possível pegar os dados do pedido de compra, erro: " + error
      );
    }
  }

  async function GetProducts() {
    setLoading(true);
    try {
      const result = await api.get(`products`);
      let prods = result.data.allProducts.map((prod) => {
        return { id: prod.id, name: prod.name, price: prod.price };
      });
      setListProducts(prods);
      if (listProducts && listProducts.length > 0) setProduct(prods[0]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setErrorMessage(
        "Não foi possível pegar os dados do pedido de compra, erro: " + error
      );
    }
  }

  function GetProductTotalPrice(product) {
    return (
      product.modification?.price ??
      product.price + product.variationPriceModification
    );
  }

  async function SubmitGenerateContract() {
    setLoading(true);
    try {
      const data = {
        orderId: order.id,
      };
      const result = await api.post(`/contracts`, data);
      if (result.data.success) {
        setSuccessMessage(`Contrato ${result.data.contractId} gerado com sucesso`);
        ClosePopUp();
        ChangePopup({
          title: "Contrato gerado",
          body: `Contrato ${result.data.contractId} gerado com sucesso!`,
          primaryText: "Ver contratos",
          secondaryText: "Fechar",
          primaryOnClick: GoToContracts,
        });
        setShowPopUp(true);
      }
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || "Erro ao gerar o contrato. Tente novamente.";
      setErrorMessage(errorMessage);
      ClosePopUp();
      ChangePopup({
        title: "Erro ao gerar contrato",
        body: errorMessage,
        primaryText: "Fechar",
        primaryOnClick: ClosePopUp,
      });
      setShowPopUp(true);
    } finally {
      setLoading(false);
    }
  }

  function GoToContracts() {
    props.history.push("/contracts");
  }

  async function SubmitAddItem() {
    try {
      setLoading(true);
      const data = {
        orderId: orderId,
        productId: product.id,
        name: product.name,
        price: CurrencyToCents(product.price).toString(),
      };
      await api.post(`/orders/addItem`, data);
      GetOrderDetails();
      setSuccessMessage(`Item: ${product.name} adicionado ao pedido!`);
      ClosePopUp();
      setLoading(false);
    } catch (error) {
      setErrorMessage(
        "Não foi possível inserir o item no pedido de compra, erro: " + error
      );
      ClosePopUp();
      setLoading(false);
    }
  }

  async function SubmitModifyPrice(product: Product) {
    try {
      setLoading(true);
      const data = {
        orderId: orderId,
        orderItemId: product.orderItemId,
        name: product.displayName,
        newPrice: product.modification.price,
      };
      await api.put("/orders/itemsPrice", data);
      GetOrderDetails();
      setSuccessMessage(`Preço do produto ${product.name} modificado!`);
      ClosePopUp();
      setLoading(false);
    } catch (error) {
      setErrorMessage(
        "Não foi possível modificar o preço do produto no pedido de compra, erro: " +
        error
      );
      ClosePopUp();
      setLoading(false);
    }
  }

  async function SubmitDeleteItem(product: Product) {
    try {
      const data = {
        orderId: orderId,
        orderItemId: product.orderItemId,
        name: product.modification?.name ?? product.name,
        price: product.modification?.price,
      };
      await api.put(`/orders/removeItem`, data);
      GetOrderDetails();
      ChangePopup({
        title: "Produto removido",
        body: `Produto ${product.name} foi removido do pedido do usuário com sucesso`,
        primaryText: "Fechar",
        primaryOnClick: ClosePopUp,
      });
      setShowPopUp(true);
    } catch (error) {
      setErrorMessage(
        "Não foi possível retirar o item do pedido de compra, erro: " + error
      );
      ClosePopUp();
    }
  }

  async function SubmitUndoDeletion(product: Product) {
    try {
      setLoading(true);
      const result = await api.put(`/orders/undoItemDeletion`, {
        orderItemId: product.orderItemId,
      });
      if (result.data.success) {
        GetOrderDetails();
        ChangePopup({
          title: "Remoção desfeita",
          body: `A remoção do item ${product.modification?.name || product.name} foi desfeita com sucesso`,
          primaryText: "Fechar",
          primaryOnClick: ClosePopUp,
        });
      }
    } catch (error) {
      setErrorMessage(
        "Não foi possível desfazer a remoção do item do pedido de compra, erro: " +
        error
      );
      ClosePopUp();
    } finally {
      setLoading(false);
    }
  }

  function onSumTotal() {
    setLoading(true);
    const sumProducts = products
      .filter((product) => !product.modification?.removed)
      .reduce((total, current) => total + GetProductTotalPrice(current), 0);
    const sumMaterials = materials.reduce(
      (total, current) => total + current.price,
      0
    );
    const sumProductsPriceRate =
      sumProducts + (sumProducts * Number.parseFloat(order.interestRate)) / 100;
    const sumMaterialsPriceRate =
      sumMaterials +
      (sumMaterials * Number.parseFloat(order.interestRate)) / 100;
    setSumMaterialPrice(sumMaterials);
    setSumMaterialsPriceRate(sumMaterialsPriceRate);
    setSumProductsPrice(sumProducts);
    setSumProductsPriceRate(sumProductsPriceRate);
    setLoading(false);
  }

  async function onShowPopUpGenerateContract() {
    if (!userData) {
      setErrorMessage("Dados do usuário não carregados. Tente novamente.");
      ChangePopup({
        title: "Erro",
        body: "Dados do usuário não carregados. Tente novamente.",
        primaryText: "Fechar",
        primaryOnClick: ClosePopUp,
      });
      setShowPopUp(true);
      return;
    }

    // Map API response fields to validation names
    const mappedUserData = {
      name: userData.name || "",
      rg: userData.rg || "",
      cpf: userData.cpf || "",
      address: userData.address || "",
      number: userData.number || "",
      neighborhood: userData.neighborhood || "",
      zip_code: userData.zip_code || "",
      state: userData.state || "",
      city: userData.city || "",
    };

    // Validate required fields
    const missingFields: string[] = [];
    if (!mappedUserData.name || mappedUserData.name.trim() === "") missingFields.push("Nome");
    if (!mappedUserData.rg || mappedUserData.rg.trim() === "") missingFields.push("RG");
    if (!mappedUserData.cpf || mappedUserData.cpf.trim() === "") missingFields.push("CPF");
    if (!mappedUserData.address || mappedUserData.address.trim() === "") missingFields.push("Rua");
    if (!mappedUserData.number || mappedUserData.number.trim() === "") missingFields.push("Número");
    if (!mappedUserData.neighborhood || mappedUserData.neighborhood.trim() === "") missingFields.push("Bairro");
    if (!mappedUserData.zip_code || mappedUserData.zip_code.trim() === "") missingFields.push("CEP");
    if (!mappedUserData.state || mappedUserData.state.trim() === "") missingFields.push("Estado");
    if (!mappedUserData.city || mappedUserData.city.trim() === "") missingFields.push("Cidade");

    if (missingFields.length > 0) {
      ChangePopup({
        title: "Campos obrigatórios ausentes",
        body: `Os seguintes campos são obrigatórios: ${missingFields.join(", ")}`,
        primaryText: "Fechar",
        primaryOnClick: ClosePopUp,
      });
      setShowPopUp(true);
      return;
    }

    const modifiedItem = products.some((item) => item.modified === true);
    const body = modifiedItem
      ? `Você alterou o valor de alguns itens porém não confirmou a alteração. Deseja gerar o contrato do pedido sem essas alterações?`
      : `Deseja gerar o contrato do pedido: ${order.id}?`;

    ChangePopup({
      title: "Gerar contrato?",
      body: body,
      primaryText: "Confirmar",
      secondaryText: "Fechar",
      primaryOnClick: () => SubmitGenerateContract(),
    });
    setShowPopUp(true);
  }

  function onShowPopUpRemoveItem(product: Product) {
    ChangePopup({
      title: "Remover item.",
      body: `Deseja remover o item: ${product.modification?.name ?? product.name}?`,
      primaryText: "Confirmar",
      secondaryText: "Fechar",
      primaryOnClick: () => SubmitDeleteItem(product),
    });
    setShowPopUp(true);
  }

  function onShowPopUpEditPrice(product: Product) {
    ChangePopup({
      title: "Editar preço.",
      body: `Deseja editar o preço do item: ${product.modification?.name ?? product.name
        } para ${CentsToHuman(product.modification.price)}`,
      primaryText: "Confirmar",
      secondaryText: "Fechar",
      primaryOnClick: () => SubmitModifyPrice(product),
    });
    setShowPopUp(true);
  }

  function ShowPopupUndoDeletion(product: Product) {
    ChangePopup({
      title: "Desfazer remoção do item.",
      body: `Deseja desfazer a remoção do item: ${product.modification?.name ?? product.name
        }`,
      primaryText: "Desfazer",
      secondaryText: "Fechar",
      primaryOnClick: () => SubmitUndoDeletion(product),
    });
    setShowPopUp(true);
  }

  function showPopUpDeletionMaterial(material: any) {
    ChangePopup({
      title: "Confirmar remoção do item.",
      body: `Deseja remover o material ${material.orderMaterialName}?`,
      primaryText: "Remover Item",
      secondaryText: "Cancelar",
      primaryOnClick: () => SubmitUndoDeletionMaterial(material.id, orderId),
    });
    setShowPopUp(true);
  }

  async function SubmitUndoDeletionMaterial(materialId: number, orderId: number) {
    setLoading(true);
    try {
      await api.put(`/orders/removeMaterial`, {
        materialId: materialId,
        orderId: orderId,
      });
      setShowPopUp(false);
      GetOrderDetails();
    } catch (err) {
      console.error(err, "Requisição falhou");
    } finally {
      setLoading(false);
    }
  }

  function ClosePopUp() {
    setShowPopUp(false);
    setShowPopUpAddItem(false);
    if (listProducts && listProducts.length > 0) setProduct(listProducts[0]);
  }

  function onChangeProduct(e) {
    let prod = listProducts.find((p) => p.id === +e.target.value);
    setProduct(prod);
  }

  function OnModifyPrice(value, product) {
    product.modification = {
      price: CurrencyToCents(value),
      name: product.name,
      removed: false,
      modified: true,
    };
    setProducts([...products]);
  }

  function ChangePopup(popupData: ChangePopupData) {
    setBodyPopUp({
      show: showPopUp,
      loading: loading,
      title: popupData.title,
      body: popupData.body,
      primaryText: popupData.primaryText,
      secondaryText: popupData.secondaryText,
      primaryDisabled: popupData.primaryText.length > 0,
      secondaryDisabled: popupData.secondaryText
        ? popupData.secondaryText?.length > 0
        : true,
      primaryOnClick: popupData.primaryOnClick,
      secondaryOnClick: popupData.secondaryOnClick,
    });
  }

  return (
    <Style className="default-page">
      <PageTitle title="Detalhes do Pedido" />
      <TwoButtonsModal
        show={showPopUp}
        onHide={ClosePopUp}
        loading={loading}
        title={bodyPopup?.title}
        body={bodyPopup?.body}
        secondaryText={bodyPopup?.secondaryText}
        secondaryOnClick={ClosePopUp}
        secondaryDisabled={loading}
        primaryText={bodyPopup?.primaryText}
        primaryOnClick={bodyPopup?.primaryOnClick}
        primaryDisabled={loading}
      />

      <TwoButtonsModal
        show={showPopUpAddItem}
        onHide={ClosePopUp}
        loading={loading}
        title={"Adicionar novo item ao pedido:"}
        secondaryText={"Fechar"}
        secondaryOnClick={ClosePopUp}
        secondaryDisabled={loading}
        primaryText={"Confirmar"}
        primaryOnClick={() => SubmitAddItem()}
        primaryDisabled={loading}
        body={
          <form>
            <div>
              <label>Produto:</label>
              <select
                name="product"
                id="product"
                value={product.id}
                onChange={(e) => onChangeProduct(e)}
              >
                {listProducts.length > 0 &&
                  listProducts.map((p) => (
                    <option key={p.id} value={p.id}>
                      {p.name}
                    </option>
                  ))}
              </select>
            </div>
            <div>
              <InputCurrency
                label="Preço:"
                id="price"
                disabled={false}
                value={CentsToHuman(parseInt(product.price)) || "R$ 0,00"}
                OnChange={(price) => setProduct({ ...product, price: price })}
              />
            </div>
          </form>
        }
      />

      <Spinner spinning={loading} />
      <ReturnButton history={props.history} />
      {errorMessage && (
        <p className="alert alert-danger">Erro: {errorMessage}</p>
      )}
      {successMessage && <p className="alert alert-info">{successMessage}</p>}

      <main className="default-main">
        <div className="formInfo panel main-form">
          <h2>Detalhes do pedido {orderId}</h2>

          <div>
            <label>Nome: </label>
            <p>{order.customerName}</p>
          </div>

          <div>
            <label>Email: </label>
            <p>{order.customerEmail}</p>
          </div>

          <div>
            <label>Telefone: </label>
            <p>{PhoneMask(order.customerPhone)}</p>
          </div>

          <div>
            <label>Opção escolhida: </label>
            <p>{ReplaceAll(planOption, "_", " ")}</p>
          </div>

          <div>
            <label>Opção de pagamento: </label>
            <p>
              {order.newPaymentOption
                ? order.newPaymentOption
                : order.paymentOption}
            </p>
          </div>

          <div>
            <label>Data de pagamento: </label>
            <p>{order.paymentDate}</p>
          </div>
        </div>

        <div className="panel">
          <section className="table-title">
            <h1>Itens</h1>
            <button onClick={() => setShowPopUpAddItem(true)}>
              Adicionar item
            </button>
          </section>
          <table className=" table table-striped table-bordered table-hover ">
            <thead>
              <tr>
                <th>Id</th>
                <th>Nome</th>
                <th>Variação</th>
                <th>Nome exibido</th>
                <th>Preço</th>
                <th>Preço variação</th>
                <th>Preço alterado</th>
                <th>Ação</th>
              </tr>
            </thead>
            <tbody>
              {products.length > 0 &&
                Sort(
                  products.filter((product) => !product.modification?.removed),
                  (product) => product.name || product.displayName
                ).map((product, index) => (
                  <tr key={product.orderItemId}>
                    <td>{product.orderItemId}</td>
                    <td>
                      {product.modification?.name
                        ? product.modification.name
                        : product.name}
                    </td>
                    <td>{product.variationName}</td>
                    <td>{product.modification?.name ?? product.displayName}</td>
                    <td className="currency">{CentsToHuman(product.price)}</td>
                    <td className="currency">
                      {CentsToHuman(product.variationPriceModification)}
                    </td>
                    <td>
                      <InputCurrency
                        label="Preço:"
                        id="price"
                        disabled={false}
                        value={CentsToHuman(GetProductTotalPrice(product))}
                        OnChange={(value) => OnModifyPrice(value, product)}
                      />
                    </td>
                    <td className="action">
                      {product.modification?.modified && (
                        <button onClick={() => onShowPopUpEditPrice(product)}>
                          <FaPen className="icon" />
                        </button>
                      )}
                      <button onClick={() => onShowPopUpRemoveItem(product)}>
                        <FaTrashAlt className="icon" />
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>

          {products.filter((product) => product.modification?.removed).length >
            0 && (
              <>
                <section className="table-title">
                  <h1>Itens removidos</h1>
                </section>
                <table className=" table table-striped table-bordered table-hover ">
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Nome</th>
                      <th>Variação</th>
                      <th>Nome exibido</th>
                      <th>Preço</th>
                      <th>Preço variação</th>
                      <th>Preço alterado</th>
                      <th>Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    {products.length > 0 &&
                      Sort(
                        products.filter(
                          (product) => product.modification?.removed
                        ),
                        (product) => product.name || product.displayName
                      ).map((product, index) => (
                        <tr key={product.orderItemId}>
                          <td>{product.orderItemId}</td>
                          <td>
                            {product.modification?.name
                              ? product.modification.name
                              : product.name}
                          </td>
                          <td>{product.variationName}</td>
                          <td>{product.displayName}</td>
                          <td className="currency">
                            {CentsToHuman(product.price)}
                          </td>
                          <td className="currency">
                            {CentsToHuman(product.variationPriceModification)}
                          </td>
                          <td className="currency">
                            {CentsToHuman(GetProductTotalPrice(product))}
                          </td>
                          <td className="action">
                            <button
                              onClick={() => ShowPopupUndoDeletion(product)}
                            >
                              <TiCancel className="icon" />
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </>
            )}
        </div>

        <div className="panel">
          <section className="table-title">
            <h1>Materiais</h1>
          </section>
          <table className=" table table-striped table-bordered table-hover ">
            <thead>
              <tr>
                <th>Id</th>
                <th>Material</th>
                <th>Preço</th>
                <th>Ação</th>
              </tr>
            </thead>
            <tbody>
              {materials.length > 0 &&
                Sort<any>(
                  materials,
                  (material) => material.orderMaterialName
                ).map((material) => (
                  <tr key={material.id}>
                    <td>{material.id}</td>
                    <td>{material.orderMaterialName}</td>
                    <td className="currency">{CentsToHuman(material.price)}</td>
                    <td className="action">
                      <button
                        onClick={() => showPopUpDeletionMaterial(material)}
                      >
                        <FaTrashAlt className="icon" />
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        <div className="panel">
          <div className="total">
            {installment && (
              <div>
                Parcelas:{" "}
                {(order.newInstallment
                  ? order.newInstallment
                  : order.installment) + "x"}
              </div>
            )}
            {installment &&
              (order.newInterestRate || order.interestRate) > 0 && (
                <div>
                  Juros:{" "}
                  {(order.newInterestRate
                    ? order.newInterestRate
                    : order.interestRate) + "%"}
                </div>
              )}

            <div>
              Total produtos{!installment && " a vista"}:{" "}
              {CentsToHuman(sumProductsPrice)}
            </div>
            {installment &&
              (order.interestRate || order.newInterestRate) > 0 && (
                <div>
                  Total de produtos com juros:{" "}
                  {CentsToHuman(sumProductsPriceRate)}
                </div>
              )}
          </div>
          <div className="total">
            <div>
              Total materiais{!installment && " a vista"}:{" "}
              {CentsToHuman(sumMaterialPrice)}
            </div>
            {installment &&
              (order.interestRate || order.newInterestRate) > 0 && (
                <div>
                  Total de materiais com juros:{" "}
                  {CentsToHuman(sumMaterialsPriceRate)}
                </div>
              )}
            {artValue > 0 && <div>Taxa ART: {CentsToHuman(artValue)}</div>}
            {cleaningTax > 0 && (
              <div>Taxa de Limpeza: {CentsToHuman(cleaningTax)}</div>
            )}
            <div>
              Total:{" "}
              <span className="currency totalCost">
                {CentsToHuman(
                  sumProductsPrice + sumMaterialPrice + artValue + cleaningTax
                )}{" "}
              </span>
            </div>
            {installment && order.interestRate > 0 && (
              <div>
                Total com juros:{" "}
                <span className="currency totalCost">
                  {CentsToHuman(sumProductsPriceRate + sumMaterialsPriceRate)}{" "}
                </span>
              </div>
            )}
            <div>
              <button
                className="btGenerateContract"
                onClick={() => onShowPopUpGenerateContract()}
              >
                Gerar Contrato
              </button>
            </div>
          </div>
        </div>
      </main>
    </Style>
  );
}
